/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
  InlineResponse200,
  InlineResponse200FromJSON,
  InlineResponse200ToJSON,
  InlineResponse2001,
  InlineResponse2001FromJSON,
  InlineResponse2001ToJSON,
  Login,
  LoginFromJSON,
  LoginToJSON,
  LoginFail,
  LoginFailFromJSON,
  LoginFailToJSON,
  LoginGetSuccess,
  LoginGetSuccessFromJSON,
  LoginGetSuccessToJSON,
  LoginPostResponse,
  LoginPostResponseFromJSON,
  LoginPostResponseToJSON,
  Notification,
  NotificationFromJSON,
  NotificationToJSON,
  Profile,
  ProfileFromJSON,
  ProfileToJSON,
  RefreshTokenResponse,
  RefreshTokenResponseFromJSON,
  RefreshTokenResponseToJSON,
  TokenRefresh,
  TokenRefreshFromJSON,
  TokenRefreshToJSON,
  User,
  UserFromJSON,
  UserToJSON,
  UserDevice,
  UserDeviceFromJSON,
  UserDeviceToJSON,
  SendSmsCodeToJSON,
  SendPhoneConfirmToJSON,
  PhoneConfirmRequestToJSON,
  PhoneConfirmRequestGetSuccessFromJSON,
  RepeatPhoneConfirmRequestToJSON,
  RepeatPhoneConfirmRequestGetSuccessFromJSON,  
  RepeatPhoneConfirmRequestGetSuccess,
  PhoneConfirmRequestGetSuccess,
  SendRepeatPhoneConfirmToJSON,
  SmsLogin,
  SmsLoginToJSON,
  SmsLoginResponse,
  SmsLoginResponseFromJSON,
} from '../models';
import { PassportData, PassportDataFromJSON, PassportDataToJSON } from '../models/PassportData';
import { RegisterProfile, RegisterProfileToJSON } from '../models/RegisterProfile';

export interface AuthV1LoginCreateRequest {
  phone: string;
  token: string;
}

export interface AuthV1LoginListRequest {
  phone: string;
  isAdmin?: boolean;
  gRecaptchaResponse: string;
  ignoreCaptchaKey?: string | null;
  checkAgreements?: boolean;
  search?: string;
  ordering?: string;
  limit?: number;
  offset?: number;
}

export type AuthV1SmsLoginRequest = SmsLogin;

export interface AuthV1PhoneConfirmRequest {
  phone: string;
  isAdmin?: boolean;
  gRecaptchaResponse: string;
  ignoreCaptchaKey?: boolean;	
}

export interface AuthV1RepeatPhoneConfirmRequest {
  phone: string;	
}


export interface AuthV1NotificationsPartialUpdateRequest {
  id: number;
  data: Notification;
}

export interface AuthV1NotificationsReadRequest {
  id: number;
}

export interface AuthV1NotificationsUpdateRequest {
  id: number;
  data: Notification;
}

export interface AuthV1ProfilePartialUpdateRequest {
  data: Profile;
}

export interface AuthV1ProfileRegisterRequest {
  data: RegisterProfile;
}

export interface AuthV1ProfilePassportUpdateRequest {
  data: PassportData;
}

export interface AuthV1TokenRefreshCreateRequest {
  data: TokenRefresh;
}

export interface AuthV1UserAttachmentsListRequest {
  search?: string;
  ordering?: string;
  limit?: number;
  offset?: number;
}

export interface AuthV1UserDevicesListRequest {
  search?: string;
  ordering?: string;
  limit?: number;
  offset?: number;
}

export interface AuthV1UserDevicesPartialUpdateRequest {
  data: UserDevice;
}

export interface AuthV1UserPartialUpdateRequest {
  data: User;
}

export interface AuthV1ConfirmEmailRequest {
  code: string;
}

/**
 *
 */
export class AuthApi extends runtime.BaseAPI {
  /**
   * Авторизация по СМС
   */
  async authV1LoginCreateRaw(
    requestParameters: AuthV1LoginCreateRequest
  ): Promise<runtime.ApiResponse<LoginPostResponse>> {
    if (requestParameters.phone === null || requestParameters.phone === undefined) {
      throw new runtime.RequiredError(
        'phone',
        'Required parameter requestParameters.phone was null or undefined when calling authV1LoginCreate.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/auth/v1/phone-number-confirmation-check`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: LoginToJSON(requestParameters),
    });

    return new runtime.JSONApiResponse(response, jsonValue => LoginPostResponseFromJSON(jsonValue));
  }

  /**
   * Авторизация по СМС
   */
  async authV1LoginCreate(requestParameters: AuthV1LoginCreateRequest): Promise<LoginPostResponse> {
    const response = await this.authV1LoginCreateRaw(requestParameters);
    return await response.value();
  }

  /**
   * Вход по коду из SMS (запасной способ к звонку)
   */
  async authV1SmsLoginCreateRaw(requestParameters: AuthV1SmsLoginRequest): Promise<runtime.ApiResponse<SmsLoginResponse>> {
    if (requestParameters.phone === null || requestParameters.phone === undefined) {
      throw new runtime.RequiredError(
        'phone',
        'Required parameter requestParameters.phone was null or undefined when calling authV1SmsLoginCreate.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/auth/v1/login/`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: SmsLoginToJSON(requestParameters),
    });

    return new runtime.JSONApiResponse(response, jsonValue => SmsLoginResponseFromJSON(jsonValue));
  }

  /**
   * Вход по коду из SMS (запасной способ к звонку)
   */
  async authV1SmsLoginCreate(requestParameters: AuthV1SmsLoginRequest): Promise<SmsLoginResponse> {
    const response = await this.authV1SmsLoginCreateRaw(requestParameters);
    return await response.value();
  }

  /**
   * Авторизация по СМС
   */
  async authV1LoginListRaw(requestParameters: AuthV1LoginListRequest): Promise<runtime.ApiResponse<LoginGetSuccess>> {
    if (requestParameters.phone === null || requestParameters.phone === undefined) {
      throw new runtime.RequiredError(
        'phone',
        'Required parameter requestParameters.phone was null or undefined when calling authV1LoginList.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    // send-sms-code - запрос кода по SMS для ЛКК (через 2 минуты после запроса звонка);
    // прежний send-sms закрыт по IP и остаётся только сайту (бронирование)
    const response = await this.request({
      path: `/auth/v1/send-sms-code/`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: PhoneConfirmRequestToJSON(requestParameters),
    });

    return new runtime.JSONApiResponse(response, jsonValue => LoginGetSuccessFromJSON(jsonValue));
  }

  /**
   * Запрос подтверждения номера телфефона
   */
  async authV1PhoneConfirm(requestParameters: AuthV1PhoneConfirmRequest): Promise<PhoneConfirmRequestGetSuccess> {
    const response = await this.authV1PhoneConfirmRaw(requestParameters);
    return await response.value();
  }

  /**
   * Запрос подтверждения номера телфефона
   */
  async authV1PhoneConfirmRaw(requestParameters: AuthV1PhoneConfirmRequest): Promise<runtime.ApiResponse<PhoneConfirmRequestGetSuccess>> {
    if (requestParameters.phone === null || requestParameters.phone === undefined) {
      throw new runtime.RequiredError(
        'phone',
        'Required parameter requestParameters.phone was null or undefined when calling authV1LoginList.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/auth/v1/phone-number-registration`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: SendPhoneConfirmToJSON(requestParameters),
    });

    return new runtime.JSONApiResponse(response, jsonValue => PhoneConfirmRequestGetSuccessFromJSON(jsonValue));
  }
  
  /**
   * Запрос подтверждения номера телфефона
   */
  async authV1RepeatPhoneConfirm(requestParameters: AuthV1RepeatPhoneConfirmRequest): Promise<RepeatPhoneConfirmRequestGetSuccess> {
    const response = await this.authV1RepeatPhoneConfirmRaw(requestParameters);
    return await response.value();
  }    

  /**
   * Запрос подтверждения номера телфефона
   */
  async authV1RepeatPhoneConfirmRaw(requestParameters: AuthV1RepeatPhoneConfirmRequest): Promise<runtime.ApiResponse<RepeatPhoneConfirmRequestGetSuccess>> {
    if (requestParameters.phone === null || requestParameters.phone === undefined) {
      throw new runtime.RequiredError(
        'phone',
        'Required parameter requestParameters.phone was null or undefined when calling authV1LoginList.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/auth/v1/phone-number-registration-repeat`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: SendRepeatPhoneConfirmToJSON(requestParameters),
    });

    return new runtime.JSONApiResponse(response, jsonValue => RepeatPhoneConfirmRequestGetSuccessFromJSON(jsonValue));
  }


  /**
   * Авторизация по СМС
   */
  async authV1LoginList(requestParameters: AuthV1LoginListRequest): Promise<LoginGetSuccess> {
    const response = await this.authV1LoginListRaw(requestParameters);
    return await response.value();
  }

  /**
   * выход из приложения
   */
  async authV1LogoutListRaw(): Promise<runtime.ApiResponse<void>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/auth/v1/logout/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.VoidApiResponse(response);
  }

  /**
   * выход из приложения
   */
  async authV1LogoutList(): Promise<void> {
    await this.authV1LogoutListRaw();
  }


  async authV1NotificationsPartialUpdateRaw(
    requestParameters: AuthV1NotificationsPartialUpdateRequest
  ): Promise<runtime.ApiResponse<Notification>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling authV1NotificationsPartialUpdate.'
      );
    }

    if (requestParameters.data === null || requestParameters.data === undefined) {
      throw new runtime.RequiredError(
        'data',
        'Required parameter requestParameters.data was null or undefined when calling authV1NotificationsPartialUpdate.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/auth/v1/notifications/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
      method: 'PATCH',
      headers: headerParameters,
      query: queryParameters,
      body: NotificationToJSON(requestParameters.data),
    });

    return new runtime.JSONApiResponse(response, jsonValue => NotificationFromJSON(jsonValue));
  }

  /**
   */
  async authV1NotificationsPartialUpdate(
    requestParameters: AuthV1NotificationsPartialUpdateRequest
  ): Promise<Notification> {
    const response = await this.authV1NotificationsPartialUpdateRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async authV1NotificationsReadRaw(
    requestParameters: AuthV1NotificationsReadRequest
  ): Promise<runtime.ApiResponse<Notification>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling authV1NotificationsRead.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/auth/v1/notifications/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => NotificationFromJSON(jsonValue));
  }

  /**
   */
  async authV1NotificationsRead(requestParameters: AuthV1NotificationsReadRequest): Promise<Notification> {
    const response = await this.authV1NotificationsReadRaw(requestParameters);
    return await response.value();
  }

  /**
   */
  async authV1NotificationsUpdateRaw(
    requestParameters: AuthV1NotificationsUpdateRequest
  ): Promise<runtime.ApiResponse<Notification>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter requestParameters.id was null or undefined when calling authV1NotificationsUpdate.'
      );
    }

    if (requestParameters.data === null || requestParameters.data === undefined) {
      throw new runtime.RequiredError(
        'data',
        'Required parameter requestParameters.data was null or undefined when calling authV1NotificationsUpdate.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/auth/v1/notifications/{id}/`.replace(`{${'id'}}`, encodeURIComponent(String(requestParameters.id))),
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
      body: NotificationToJSON(requestParameters.data),
    });

    return new runtime.JSONApiResponse(response, jsonValue => NotificationFromJSON(jsonValue));
  }

  /**
   */
  async authV1NotificationsUpdate(requestParameters: AuthV1NotificationsUpdateRequest): Promise<Notification> {
    const response = await this.authV1NotificationsUpdateRaw(requestParameters);
    return await response.value();
  }

  /**
   * Обновление профиля пользователя
   */
  async authV1ProfilePartialUpdateRaw(
    requestParameters: AuthV1ProfilePartialUpdateRequest
  ): Promise<runtime.ApiResponse<Profile>> {
    if (requestParameters.data === null || requestParameters.data === undefined) {
      throw new runtime.RequiredError(
        'data',
        'Required parameter requestParameters.data was null or undefined when calling authV1ProfilePartialUpdate.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/auth/v1/profile/`,
      method: 'PATCH',
      headers: headerParameters,
      query: queryParameters,
      body: ProfileToJSON(requestParameters.data),
    });

    return new runtime.JSONApiResponse(response, jsonValue => ProfileFromJSON(jsonValue));
  }

  /**
   * Обновление профиля пользователя
   */
  async authV1ProfilePartialUpdate(requestParameters: AuthV1ProfileRegisterRequest): Promise<Profile> {
    const response = await this.authV1ProfilePartialUpdateRaw(requestParameters);
    return await response.value();
  }

  /**
   * Обновление профиля пользователя при регистрации
   */
  async authV1ProfileRegisterRaw(
    requestParameters: AuthV1ProfileRegisterRequest
  ): Promise<runtime.ApiResponse<Profile>> {
    if (requestParameters.data === null || requestParameters.data === undefined) {
      throw new runtime.RequiredError(
        'data',
        'Required parameter requestParameters.data was null or undefined when calling authV1ProfilePartialUpdate.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/auth/v1/profile/`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: RegisterProfileToJSON(requestParameters.data),
    });

    return new runtime.JSONApiResponse(response, jsonValue => ProfileFromJSON(jsonValue));
  }

  /**
   * Обновление профиля пользователя при регистрации
   */
  async authV1ProfileRegister(requestParameters: AuthV1ProfileRegisterRequest): Promise<Profile> {
    const response = await this.authV1ProfilePartialUpdateRaw(requestParameters);
    return await response.value();
  }

  async authV1ConfirmEmailRaw(requestParameters: AuthV1ConfirmEmailRequest): Promise<runtime.ApiResponse<Profile>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/auth/v1/profile/confirm-email`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: {
        code: requestParameters.code,
      },
    });

    return new runtime.JSONApiResponse(response, jsonValue => ProfileFromJSON(jsonValue));
  }

  /**
   * Обновление профиля пользователя
   */
  async authV1ConfirmEmail(): Promise<Profile> {
    const response = await this.authV1ProfileReadRaw();
    return await response.value();
  }

  async authV1ProfilePassportUpdateRaw(
    requestParameters: AuthV1ProfilePassportUpdateRequest
  ): Promise<runtime.ApiResponse<PassportData>> {
    if (requestParameters.data === null || requestParameters.data === undefined) {
      throw new runtime.RequiredError(
        'data',
        'Required parameter requestParameters.data was null or undefined when calling authV1ProfilePassportUpdate.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/auth/v1/profile/passport`,
      method: 'PATCH',
      headers: headerParameters,
      query: queryParameters,
      body: PassportDataToJSON(requestParameters.data),
    });

    return new runtime.JSONApiResponse(response, jsonValue => PassportDataFromJSON(jsonValue));
  }

  /**
   * Обновление профиля пользователя
   */
  async authV1ProfilePassportUpdate(requestParameters: AuthV1ProfilePassportUpdateRequest): Promise<PassportData> {
    const response = await this.authV1ProfilePassportUpdateRaw(requestParameters);
    return await response.value();
  }

  /**
   * Обновление профиля пользователя
   */
  async authV1ProfileReadRaw(): Promise<runtime.ApiResponse<Profile>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/auth/v1/profile/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => ProfileFromJSON(jsonValue));
  }

  /**
   * Обновление профиля пользователя
   */
  async authV1ProfileRead(): Promise<Profile> {
    const response = await this.authV1ProfileReadRaw();
    return await response.value();
  }

  /**
   */
  async authV1TokenRefreshCreateRaw(
    requestParameters: AuthV1TokenRefreshCreateRequest
  ): Promise<runtime.ApiResponse<RefreshTokenResponse>> {
    if (requestParameters.data === null || requestParameters.data === undefined) {
      throw new runtime.RequiredError(
        'data',
        'Required parameter requestParameters.data was null or undefined when calling authV1TokenRefreshCreate.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/auth/v1/token/refresh/`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: TokenRefreshToJSON(requestParameters.data),
    });

    return new runtime.JSONApiResponse(response, jsonValue => RefreshTokenResponseFromJSON(jsonValue));
  }

  /**
   */
  async authV1TokenRefreshCreate(requestParameters: AuthV1TokenRefreshCreateRequest): Promise<RefreshTokenResponse> {
    const response = await this.authV1TokenRefreshCreateRaw(requestParameters);
    return await response.value();
  }

  /**
   * Просмотр своих документов
   */
  async authV1UserAttachmentsListRaw(
    requestParameters: AuthV1UserAttachmentsListRequest
  ): Promise<runtime.ApiResponse<InlineResponse200>> {
    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.search !== undefined) {
      queryParameters['search'] = requestParameters.search;
    }

    if (requestParameters.ordering !== undefined) {
      queryParameters['ordering'] = requestParameters.ordering;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters['limit'] = requestParameters.limit;
    }

    if (requestParameters.offset !== undefined) {
      queryParameters['offset'] = requestParameters.offset;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/auth/v1/user/attachments/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => InlineResponse200FromJSON(jsonValue));
  }

  /**
   * Просмотр своих документов
   */
  async authV1UserAttachmentsList(requestParameters: AuthV1UserAttachmentsListRequest): Promise<InlineResponse200> {
    const response = await this.authV1UserAttachmentsListRaw(requestParameters);
    return await response.value();
  }

  /**
   * Просмотр своих устройств
   */
  async authV1UserDevicesListRaw(
    requestParameters: AuthV1UserDevicesListRequest
  ): Promise<runtime.ApiResponse<InlineResponse2001>> {
    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.search !== undefined) {
      queryParameters['search'] = requestParameters.search;
    }

    if (requestParameters.ordering !== undefined) {
      queryParameters['ordering'] = requestParameters.ordering;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters['limit'] = requestParameters.limit;
    }

    if (requestParameters.offset !== undefined) {
      queryParameters['offset'] = requestParameters.offset;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/auth/v1/user/devices/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => InlineResponse2001FromJSON(jsonValue));
  }

  /**
   * Просмотр своих устройств
   */
  async authV1UserDevicesList(requestParameters: AuthV1UserDevicesListRequest): Promise<InlineResponse2001> {
    const response = await this.authV1UserDevicesListRaw(requestParameters);
    return await response.value();
  }

  /**
   * Просмотр своих устройств
   */
  async authV1UserDevicesPartialUpdateRaw(
    requestParameters: AuthV1UserDevicesPartialUpdateRequest
  ): Promise<runtime.ApiResponse<UserDevice>> {
    if (requestParameters.data === null || requestParameters.data === undefined) {
      throw new runtime.RequiredError(
        'data',
        'Required parameter requestParameters.data was null or undefined when calling authV1UserDevicesPartialUpdate.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/auth/v1/user/devices/`,
      method: 'PATCH',
      headers: headerParameters,
      query: queryParameters,
      body: UserDeviceToJSON(requestParameters.data),
    });

    return new runtime.JSONApiResponse(response, jsonValue => UserDeviceFromJSON(jsonValue));
  }

  /**
   * Просмотр своих устройств
   */
  async authV1UserDevicesPartialUpdate(requestParameters: AuthV1UserDevicesPartialUpdateRequest): Promise<UserDevice> {
    const response = await this.authV1UserDevicesPartialUpdateRaw(requestParameters);
    return await response.value();
  }

  /**
   * Добавить, получить, изменить email пользователя
   */
  async authV1UserPartialUpdateRaw(
    requestParameters: AuthV1UserPartialUpdateRequest
  ): Promise<runtime.ApiResponse<User>> {
    if (requestParameters.data === null || requestParameters.data === undefined) {
      throw new runtime.RequiredError(
        'data',
        'Required parameter requestParameters.data was null or undefined when calling authV1UserPartialUpdate.'
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/auth/v1/user/`,
      method: 'PATCH',
      headers: headerParameters,
      query: queryParameters,
      body: UserToJSON(requestParameters.data),
    });

    return new runtime.JSONApiResponse(response, jsonValue => UserFromJSON(jsonValue));
  }

  /**
   * Добавить, получить, изменить email пользователя
   */
  async authV1UserPartialUpdate(requestParameters: AuthV1UserPartialUpdateRequest): Promise<User> {
    const response = await this.authV1UserPartialUpdateRaw(requestParameters);
    return await response.value();
  }

  /**
   * Добавить, получить, изменить email пользователя
   */
  async authV1UserReadRaw(): Promise<runtime.ApiResponse<User>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/auth/v1/user/`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => UserFromJSON(jsonValue));
  }

  /**
   * Добавить, получить, изменить email пользователя
   */
  async authV1UserRead(): Promise<User> {
    const response = await this.authV1UserReadRaw();
    return await response.value();
  }

  async authV1BasisWidgetRaw(): Promise<runtime.ApiResponse<string>> {
    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-App-Version'] = this.configuration.apiKey('X-App-Version'); // AppVersion authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] = this.configuration.apiKey('Authorization'); // Bearer authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Id'] = this.configuration.apiKey('X-Device-Id'); // DeviceId authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Device-Type'] = this.configuration.apiKey('X-Device-Type'); // DeviceType authentication
    }

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['X-Os-Version'] = this.configuration.apiKey('X-Os-Version'); // OsVersion authentication
    }

    const response = await this.request({
      path: `/auth/v1/basis/widget`,
      method: 'GET',
      headers: headerParameters,
    });

    return new runtime.JSONApiResponse(response, jsonValue => jsonValue);
  }

  /**
   * Добавить, получить, изменить email пользователя
   */
  async authV1BasisWidget(): Promise<string> {
    const response = await this.authV1BasisWidgetRaw();
    return await response.value();
  }
}
